<!--  -->
<template>
  <div class="application_box">
    <div class="search_box">
      <!-- <div>
        <el-button type="primary" icon="el-icon-search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right">重置</el-button>
      </div> -->

      <el-button type="success" @click="addapplication">新增应用</el-button>
      <el-button type="primary" @click="updataanonymous">飞书企业</el-button>

    </div>
    <div class="table_box">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="应用名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="appId"
          label="appId"
          width="180"
          align="center"
        />
        <el-table-column
          prop="appSecret"
          label="appSecret"
          width="180"
          align="center"
        />
        <el-table-column
          prop="encryptKey"
          label="encryptKey"
          width="180"
          align="center"
        />
        <el-table-column
          prop="validationToken"
          label="validationToken"
          width="180"
          align="center"
        />
        <el-table-column
          align="center"
          prop="work_status"
          label="操作"
          width="200"
        >
          <!-- slot-scope="scope" -->
          <template slot-scope="scope">
            <div class="btn-wrap-box">
              <el-button type="warning" size="mini" @click="editapplication(scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="deletering(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="addtype === 1 ? '新增应用' : '编辑应用'"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="28%"
    >
      <apanagement ref="addapp" @appcallback="appcallback" />
    </el-dialog>
    <el-drawer
      title="飞书企业"
      :visible.sync="anonymousVisible"
      :destroy-on-close="true"
      :wrapper-closable="false"
      size="40%"
    >
      <anonymous @close="close" />
    </el-drawer>
  </div>
</template>

<script>
import apanagement from './components/apanagement.vue'
import anonymous from './components/anonymous.vue'
import { applicationlist, deltefiltering } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'Businessmanagement',
  components: {
    apanagement,
    anonymous,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false, // 新增应用弹窗
      anonymousVisible: false, // 飞书企业弹窗
      addtype: null, // 判断显示新增还是编辑
      tableData: [],
      total: null, // 总页数
      // 获取应用列表参数
      query: {
        page: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.applicationlists()
  },
  mounted() {

  },
  methods: {
    // 获取应用列表
    async applicationlists() {
      const data = await applicationlist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data.list)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.applicationlists()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.applicationlists()
    },
    // 新增应用
    addapplication() {
      this.dialogVisible = true
      this.addtype = 1
      this.$nextTick(() => {
        this.$refs.addapp.send(1)
      })
    },
    // 编辑应用
    editapplication(row) {
      this.dialogVisible = true
      this.addtype = 2
      this.$nextTick(() => {
        this.$refs.addapp.send(2, row)
      })
    },
    // 飞书企业
    updataanonymous() {
      this.anonymousVisible = true
    },
    // 删除
    deletering(id) {
      this.$confirm('确定要删除次应用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deltefiltering({
          id: id
        }).then(() => {
          this.applicationlists()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    //  新增企业的回调
    close() {
      this.anonymousVisible = false
      this.applicationlists()
    },
    // 新增应用的回调
    appcallback() {
      console.log('6666')
      this.dialogVisible = false
      this.applicationlists()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.application_box{
  padding: 30px;
}
.table_box{
  margin: 20px 0px 0px 0px;
}
.search_box{
  display: flex;
  gap:10px;
  align-items: center;
}
</style>
